import React, {
    PropsWithChildren,
    ReactNode,
    useEffect,
    useState,
  } from 'react';
  import { Redirect } from 'react-router';
  import { useSelector } from 'react-redux';
  import { RootState } from '../../models/RootState';
  import { isCasinoEnabled } from '../../hooks/domainConfigHook';
  
  interface Props {
    children: ReactNode;
  }
  
  const CasinoRoutes: React.FC<PropsWithChildren<Props>> = ({ children }) => {
    const {
      domainConfig: { casinoEnabled },
      allowedConfig,
    } = useSelector((state: RootState) => state.common);
    const [allowCasinoRoutes, setAllowCasinoRoutes] = useState(true);
  
    useEffect(() => {
      setAllowCasinoRoutes(isCasinoEnabled(casinoEnabled, allowedConfig));
    }, [casinoEnabled, allowedConfig]);
  
    return <>{allowCasinoRoutes ? children : <Redirect to={'/home'} />}</>;
  };
  
  export default CasinoRoutes;
  